import { Box, Typography, useTheme } from "@mui/material";
import { colorPalette } from "@/themes";

const BADGE_COLORS_DARK = {
    blue: {
        bg: colorPalette.blue.dark.three,
        border: colorPalette.blue.light.one,
        text: colorPalette.blue.light.one,
    },
    green: {
        bg: colorPalette.green.dark.three,
        border: colorPalette.green.dark.main,
        text: colorPalette.green.dark.main,
    },
    orange: {
        bg: colorPalette.orange.dark.three,
        border: colorPalette.orange.dark.main,
        text: colorPalette.orange.dark.main,
    },
    grey: {
        bg: colorPalette.grey.dark.two,
        border: colorPalette.grey.light.one,
        text: colorPalette.grey.light.one,
    },
};
const BADGE_COLORS_LIGHT = {
    blue: {
        bg: colorPalette.blue.light.three,
        border: colorPalette.blue.light.main,
        text: colorPalette.blue.light.main,
    },
    green: {
        bg: colorPalette.green.light.three,
        border: colorPalette.green.dark.main,
        text: colorPalette.green.dark.two,
    },
    orange: {
        bg: colorPalette.orange.light.three,
        border: colorPalette.orange.dark.main,
        text: colorPalette.orange.dark.two,
    },
    grey: {
        bg: colorPalette.grey.light.three,
        border: colorPalette.grey.light.one,
        text: colorPalette.grey.dark.one,
    },
};

const StatusBadge = ({ label, color = "grey" }) => {
    const theme = useTheme();
    const palette =
        theme.palette.mode === "dark" ? BADGE_COLORS_DARK : BADGE_COLORS_LIGHT;
    const c = palette[color] || palette.grey;
    return (
        <Box
            sx={{
                background: c.bg,
                border: `0.6px solid ${c.border}`,
                borderRadius: "1000px",
                px: "10px",
                py: "6px",
                display: "inline-flex",
                alignItems: "center",
                flexShrink: 0,
            }}
        >
            <Typography
                sx={{
                    fontSize: 11,
                    color: c.text,
                    fontFamily: "Inter Tight, sans-serif",
                    lineHeight: 1,
                    whiteSpace: "nowrap",
                }}
            >
                {label}
            </Typography>
        </Box>
    );
};

export default StatusBadge;
